import { rem, type MantineTheme } from "@mantine/core";

/** Consistent rounding (px) for inputs, buttons, and form-adjacent controls */
export const UI_FIELD_RADIUS_PX = 12;
export const FIELD_RADIUS = UI_FIELD_RADIUS_PX;

/** Modal / dialog surfaces (popup modals) */
export const MODAL_RADIUS_PX = 16;

/** Segmented control inner pills — tighter than text fields */
export const SEGMENTED_CONTROL_RADIUS_PX = 8;

/** Capsule pills for Badge / Pill */
export const TAG_PILL_RADIUS = rem(9999);

const TAG_SURFACE = {
  orange: { bg: "#FFF1E6", fg: "#C2410C", border: "#FDBA94" },
  blue: { bg: "#E8F1FF", fg: "#1D4ED8", border: "#93C5FD" },
  violet: { bg: "#F3EEFF", fg: "#6D28D9", border: "#C4B5FD" },
  green: { bg: "#DCFCE7", fg: "#047857", border: "#6EE7B7" },
  gray: { bg: "#F1F5F9", fg: "#334155", border: "#CBD5E1" },
  red: { bg: "#FEE2E2", fg: "#B91C1C", border: "#FCA5A5" },
} as const;

const TAG_COLOR_MAP: Record<string, keyof typeof TAG_SURFACE> = {
  orange: "orange",
  blue: "blue",
  violet: "violet",
  grape: "violet",
  green: "green",
  teal: "green",
  gray: "gray",
  red: "red",
  yellow: "orange",
  brand: "violet",
  indigo: "blue",
  cyan: "blue",
};

export function dashboardTagLightStyle(
  theme: MantineTheme,
  color: unknown,
  variant: string | undefined,
) {
  if (variant !== "light") return {};
  const raw = String(color ?? theme.primaryColor);
  const baseName = raw.split(".")[0] ?? "";
  const surfaceKey = TAG_COLOR_MAP[baseName];
  if (!surfaceKey) return {};
  const t = TAG_SURFACE[surfaceKey];
  return {
    backgroundColor: t.bg,
    color: t.fg,
    border: `${rem(1)} solid ${t.border}`,
    boxSizing: "border-box" as const,
  };
}

export const DROPDOWN_RADIUS = rem(12);
